
import React, {Component} from 'react'
export default class SearchFieldRow extends Component{

constructor(props){
    super(props);

    this.state = {data: this.props.data };
    this.data_types = this.props.data_types;
    this.possible_fields = this.props.possible_fields;
    this.rowHasChanged = this.rowHasChanged.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.rowDeleted = this.rowDeleted.bind(this);
    this.renderPossibleFields = this.renderPossibleFields.bind(this);
  }

  componentDidMount(){

  }


  rowHasChanged(old_values){

    this.props.updateRow(this.state.data, old_values);
  }

  rowDeleted(event){
    this.props.removeRow(this.state.data);
  }


  handleChange(event){
    var d = this.state.data;
    var old_values = d;

    if (event.target.type == 'checkbox'){
      d[event.target.name] = event.target.checked;
    }
    else
    {
     d[event.target.name] = event.target.value
    }
    this.setState({data: d});
    this.rowHasChanged(old_values);
  }

  handleFieldChange(event){
    var d = this.state.data;
    d.product_type_question_id = event.target.value
    this.setState({data: d});
    this.rowHasChanged(d);
  }


  renderSelect(){
    var t = this;
    let options = t.data_types.map(function(m, index){
      return (<option key={index} value={m}>{m}</option>);
    });

      return (
        <select onChange={t.handleChange} name="data_type" className="form-control" value={t.state.data.data_type}>
          {options}
        </select>
      );

  }

  renderPossibleFields(){
    var t = this;

    let options = t.possible_fields.map(function(m, index){
      return (<option key={index} value={m.id}>{m.type_name} - {m.name}</option>);
    });

    return (
      <select onChange={t.handleFieldChange} name="possible_fields" className="form-control" value={t.state.data.product_type_question_id}>
        {options}
      </select>
    );
  }


  render (){
    var t = this;

    return (
      <tr key={t.state.data.id}>
      <td><input type="text" name="label" defaultValue={t.state.data.label} onChange={t.handleChange} className="form-control" ></input></td>
      <td>{t.renderPossibleFields()}</td>
      <td>{t.renderSelect()}</td>
      <td><input type="checkbox" checked={t.state.data.is_filter} onChange={t.handleChange} name="is_filter" className="form-control" ></input></td>
      <td><input type="number" name="order"  defaultValue={t.state.data.order} onChange={t.handleChange} className="form-control" style={{width: "80px"}} /> </td>
      <td><button className="btn btn-danger" onClick={t.rowDeleted} ><i className="glyphicon glyphicon-trash"></i></button></td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/app/components/search_field_row.jsx